import { render } from "./videoList.vue?vue&type=template&id=71e58dd2&scoped=true"
import script from "./videoList.vue?vue&type=script&lang=js"
export * from "./videoList.vue?vue&type=script&lang=js"

import "./videoList.vue?vue&type=style&index=0&id=71e58dd2&lang=scss"
import "./videoList.vue?vue&type=style&index=1&id=71e58dd2&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e58dd2"]])

export default __exports__